import React from 'react'
import PropTypes from 'prop-types'
import loadable from '@loadable/component'
import { graphql } from 'react-apollo'
import loadGames from './loadGames.gql'

const ComponentResizer = loadable(() => import('@albatross/common-components/dist/components/ComponentResizer'))
const GamesRow = loadable(() => import('@albatross/common-components/dist/components/GamesRow/GamesRow.js'))

const GamesRowContainer = (props) => {
  const { data, venture, background, clickTag, campaignHomepage, enableContentful } = props
  if (data.loading) {
    return null
  }
  if (!data.loading && data.error) {
    return data.error
  }
  const games = data.games ?? data.contentfulGames ?? []

  return (
    <ComponentResizer>
      <GamesRow
        background={background}
        cta={clickTag}
        campaignHomepage={campaignHomepage}
        games={games}
        venture={venture}
        enableContentful={enableContentful}
      />
    </ComponentResizer>
  )
}

GamesRowContainer.propTypes = {
  data: PropTypes.object.isRequired,
  clickTag: PropTypes.string,
  campaignHomepage: PropTypes.string,
  background: PropTypes.string,
  venture: PropTypes.string,
  enableContentful: PropTypes.bool
}

function getVariables (props) {
  const variables = {
    published: true,
    released: true,
    enableContentful: props.enableContentful ?? false
  };

  ['gameIds', 'categoryId', 'tags', 'sort', 'limit', 'sortOrder'].forEach((property) => {
    if (props.query && props.query[property]) {
      variables[property] = props.query[property]
    }
  })
  return variables
}

export default graphql(loadGames, {
  options: (props) => {
    return { variables: getVariables(props) }
  }
})(GamesRowContainer)
